import { Dispatch } from '@reduxjs/toolkit';
import slice, { VerificationState } from './ingestSlice';
import AlertActions from '../alerts/actions';
import {
  approveVerificationReport,
  pollBQIngest,
  cancelIngest,
} from '../../api/ingest';
import { AlertType } from '../../common/domain/ApplicationAlert';
import { ErrorResponse } from '../../common/domain/responses';

const { actions } = slice;

export default class VerificationActions {
  constructor(private dispatch: Dispatch) {}

  cancelVerification(state: VerificationState) {
    this.dispatch(actions.cancellingVerification());
    setTimeout(() => {
      cancelIngest(state.ingestId, state.group.id);
      this.dispatch(actions.resetUpload());
    }, 1500);
  }

  approveVerificationReport(state: VerificationState) {
    this.dispatch(
      actions.updateProgress({
        message: 'Processing upload...',
        type: 'verification',
        value: 50,
      }),
    );
    this.dispatch(actions.approveErrorsAndDupes({ approval: true }));
    approveVerificationReport({
      groupId: state.group.id,
      ingestId: state.ingestId,
      approval: state.errorsAccepted,
    })
      .then(() => {
        const m = pollBQIngest(
          state.ingestId,
          state.group.id,
          (x) => x.ingestedAt > 0,
          (x) => x.bigQueryIngest?.Status[0] == 'FAILED',
        );
        return m;
      })
      .then((response) => {
        this.dispatch(actions.resetUpload());
        new AlertActions(this.dispatch).add({
          header: 'Upload Success',
          body: 'The file was uploaded successfully.',
          rowsUploaded: response.rowsIngested - response.duplicateCount,
          numberOfErrors: response.rowsWithErrors,
          potentialDupes: response.duplicateCount,
          rowsWithErrors: response.rowsWithErrors,
          type: AlertType.UPLOAD,
          groupId: state.group.id,
          ingestId: state.ingestId,
        });
      })
      .catch((result: ErrorResponse) => {
        this.dispatch(actions.initializeVerification(state));
        const detailedErrorMessage = errorHandler(result);
        new AlertActions(this.dispatch).add({
          header: 'Upload Error',
          body:
            detailedErrorMessage ??
            'An unexpected error occurred. Please try again.',
          type: AlertType.ERROR,
        });
      });
  }
}

function errorHandler(result): string | null {
  if (result.error) return result.error;
  if (result.errors && result.errors.length > 0)
    return result.errors
      .map((error) =>
        error.message ? error.message.toString() : error.toString(),
      )
      .join('\n');
  if (
    result.bigQueryIngest != null &&
    result.bigQueryIngest.Status === 'FAILED'
  )
    return 'BigQuery Ingest Failure';
  return null;
}
